
import { useEffect, useState } from "react";

function TimeRemain({
  startDate,
  subtitle,
  onCountdownFinish,
  fontSize,
  fontColor,
  flexDirection,
  showClock = true,
  showSeconds = true,
  variant = "default",
}) {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (!startDate) return;

    const lockTime = new Date(startDate);

    const updateCountdown = () => {
      const now = new Date();
      const diffMs = lockTime - now;

      if (diffMs <= 0) {
        setTimeLeft("EVENT STARTED");
        onCountdownFinish?.();
        return;
      }

      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
      const seconds = Math.floor((diffMs / 1000) % 60);

      const parts = [
        `${days}d`,
        `${hours}h`,
        `${minutes}m`,
      ];

      if (showSeconds) parts.push(`${seconds}s`);

      setTimeLeft(parts.join(" "));
    };

    updateCountdown();

    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [startDate, onCountdownFinish, showSeconds]);

  return (
    <div className={`time-remain time-remain--${variant}`}>
      {subtitle && (
        <p
          className="countdown-subtitle"
          style={{
            fontSize: "12px",
            opacity: 0.6,
            fontWeight: 500,
            color: "white",
          }}
        >
          {subtitle}
        </p>
      )}

      <div
        className="time-remain-content"
        style={{
          flexDirection,
        }}
      >
        <div className="countdown-tiles">
          {timeLeft === "EVENT STARTED" ? (
            <div className="countdown-finished">
              EVENT STARTED
            </div>
          ) : (
            timeLeft.split(" ").filter(Boolean).map((part) => {
              const [value, unit] = [
                part.slice(0, -1),
                part.slice(-1),
              ];

              const labels = {
                d: "DAYS",
                h: "HOURS",
                m: "MINUTES",
                s: "SECONDS",
              };

              return (
                <div className="countdown-tile" key={unit}>
                  <span className="countdown-value">
                    {value.padStart(2, "0")}
                  </span>

                  <span className="countdown-unit">
                    {labels[unit]}
                  </span>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}

export default TimeRemain;
